import setWaitingHallUpdate from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setWaitingHallUpdate';
import setSectorWithSeats from './setSectorWithSeats';
import initializeSeatings from './initializeSeatings';

function initializeSectorDefinition(sectorData) {
    return async (dispatch) => {
        dispatch(setSectorWithSeats(sectorData));
        dispatch(setWaitingHallUpdate(true));

        try {
            await dispatch(initializeSeatings(null, { sector_id: sectorData.id }));
        } finally {
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default initializeSectorDefinition;
